module.exports = __webpack_public_path__ + "media/img/search/yellow_buildings-f13be1efe8f8c329efc6060e8135d555.png";